export var FontVariant = {
  TextExtraSmall: 'text-extra-small',
  TextSmall: 'text-small',
  TextNormal: 'text-normal',
  TextEmphasis: 'text-emphasis',
  TextExtraLarge: 'text-extra-large',
  LabelExtraSmall: 'label-extra-small',
  LabelSmall: 'label-small',
  LabelNormal: 'label-normal',
  LabelEmphasis: 'label-emphasis',
  LabelExtraLarge: 'label-extra-large',
  ButtonXs: 'btn-xs',
  ButtonSm: 'btn-sm',
  ButtonMd: 'btn-md',
  ButtonLg: 'btn-lg',
  ButtonXl: 'btn-xl',
  InputSm: 'input-sm',
  InputMd: 'input-md'
};